import { FC } from 'react';

interface HtmlContentProps {
  style?: React.CSSProperties;
  className?: string;
  children: string | TrustedHTML;
  stripeStype?: boolean;
  ref?: any;
}

const HtmlContent: FC<HtmlContentProps> = props => {
  const { className = '', style, children, stripeStype = false, ref } = props;

  const processContent = (content: string) => {
    if (stripeStype) {
      content = content.replace(/style=".*?"/gm, '');
    }

    // Convert <ul> and <li> tags to formatted text with bullet points
    content = content
      .replace(/<ul>/g, '<div class="custom-list unordered-list">')
      .replace(/<\/ul>/g, '</div>')
      .replace(/<ol>/g, '<div class="custom-list ordered-list">')
      .replace(/<\/ol>/g, '</div>')
      .replace(/<li>/g, '<div class="list-item">')
      .replace(/<\/li>/g, '</div>')
      .replace(/<br\s*\/?>/g, '<br />');

    return content;
  };

  const content =
    typeof children === 'string' ? processContent(children) : children;

  return (
    <div
      ref={ref}
      style={style}
      className={`${className} html-content`}
      dangerouslySetInnerHTML={{ __html: content || '' }}
    />
  );
};

export default HtmlContent;
